import { render, staticRenderFns } from "./HomeTab.vue?vue&type=template&id=e003a8a0&scoped=true"
import script from "./HomeTab.vue?vue&type=script&lang=js"
export * from "./HomeTab.vue?vue&type=script&lang=js"
import style0 from "./HomeTab.vue?vue&type=style&index=0&id=e003a8a0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e003a8a0",
  null
  
)

export default component.exports